/* CSS */
import "@js/parts/css";

/* Non-alpine JS */
import './parts/floatingLabels';

/**
 * Alpine JS
 * Best to put it last so that all other potential JS is available
 * when components start getting initialized.
*/
import Alpine from 'alpinejs';
import logoCarousel from './parts/logoCarousel';
import trapFocus from './parts/trapFocus';
import tabbedCards from './parts/tabbedCards';
import solutionCardCarousel from './parts/solutionCardCarousel';
import resourceEntryCarousel from './parts/resourceEntryCarousel';
import filterEntries from './parts/filterEntries';
import sharePost from './parts/sharePost';
import marketingNotification from './parts/marketingNotification';
import "@js/stores/app.js";

/* Register components */
Alpine.data('logoCarousel', logoCarousel);
Alpine.data('trapFocus', trapFocus);
Alpine.data('tabbedCards', tabbedCards);
Alpine.data('solutionCardCarousel', solutionCardCarousel);
Alpine.data('resourceEntryCarousel', resourceEntryCarousel);
Alpine.data('filterEntries', filterEntries);
Alpine.data('sharePost', sharePost);
Alpine.data('marketingNotification', marketingNotification);

Alpine.start();

/**
 * Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
 */
if (import.meta.hot) {
  import.meta.hot.accept(() => {
    console.log("HMR");
  });
}
